<template>
  <div class="main1">
    <div class="header">
        <img src="/static/img/logo.png" class="h-left">
        <div class="searchInput" v-if="searchInput">
            <headerSearch @searchInput="toogleSearchInput">
            </headerSearch>
        </div>
        <div class="h-right">
            <div v-if="!searchInput" style="display:flex;min-width:750px;">
                <router-link :to="{path: '/home'}" active-class="active" >首页</router-link>
                <router-link :to="{path: '/lawyer'}" active-class="active" >商事律师</router-link>
                <router-link :to="{path: '/legalConsult'}" active-class="active" >企业法律咨询</router-link>
                <router-link :to="{path: '/legalDepartment'}" active-class="active" >企业法务部</router-link>
                <router-link :to="{path: '/legalCourse'}" active-class="active" >企业法务通</router-link>
                <!-- <router-link :to="{path: '/help'}" active-class="active" >帮助中心</router-link> -->
                <div class="right-tab" @click="toCompany" title="跳转企业版">企业版</div>
                <div class="right-tab" @click="toLaywer"title="跳转律师版">律师版</div>
                <div class="r-imgs">
                    <img src="/static/img/search.png" class="r-img" @click.stop="searchInput = true">
                    <notice v-if="loginStatus">
                        <img src="/static/img/notice.png" class="r-img">
                    </notice>
                </div>
            </div>
            <div class="r-title">
                <div v-if="loginStatus">
                    <div class="r-login" @click="$router.push({name: 'personalCenter', params: {id: $store.state.mineInfo.id}})">
                        <span class="r-name">{{$store.state.mineInfo.real_name||$store.state.mineInfo.name}}</span>
                        <div class="r-name-list">
                            <img class="r-name-img" :src="$avatarHash($store.state.mineInfo.id)">
                            <div class="r-name-icon"></div>
                        </div>
                    </div>
                    <div class="r-card">
                        <div @click="toLaywer">我是律师</div>
                        <div @click="toCompany">我是企业</div>
                        <div @click="$router.push({path: '/personalSetter/accountSet'})">账号设置</div>
                        <div @click="logOut">退出账号</div>
                    </div>
                </div>
                <div v-if="!loginStatus" class="r-btn" @click="$store.commit('changeLoginModalStatus', {display: true, type: 'login'})">登录/注册</div>
            </div>
        </div>
    </div>


    <!-- 登录组件 -->
    <vlogin v-if="!loginStatus"></vlogin>

  </div>
</template>

<script>
import vlogin from "@/components/login";
import notice from "@/components/notice";
import headerSearch from "@/components/search/headerSearch";
export default {
  name: 'Header',
  data () {
    return {
      searchInput:false
    }
  },
  components: {vlogin,notice,headerSearch},
  computed:{
    loginStatus() {
      return this.$store.state.loginStatus;
    },
  },
  methods:{
    logOut() {
      // 先关闭socket
      if(window.socket){
        window.socket.close();
      }
      this.$ajax('post', 'logout', (data) => {
        // 重置状态
        this.$store.commit('clearalldata');
        this.$store.commit('changebindPhone', false)
        this.$message.success('退出登录成功！');
        this.$router.push({name: 'home'});
      });
    },
    toogleSearchInput(status) {
      this.searchInput = status
    },
    toCompany(){
        // window.open('http://company-test.honsenflag.com', "_blank");
        this.$gotoCompany('home');
    },
    toLaywer(){
        this.$gotoLawyer('home');
    },
  }
}
</script>

<style lang="stylus" scoped>
.main1
    width:100%;
    min-width: 1440px;
    // max-width: 1920px;
    height:80px;
    // line-height:80px;
    position: fixed;
    top:0px;
    z-index:1000;
    background-color:#FFFFFF;
    box-shadow:0px 4px 20px 0px rgba(0,0,0,0.1);
    .header
        margin:0 15%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        height:100%;
        .searchInput
            width: 345px;
            margin-left:550px;
            // height:40px;
        .h-left
            width:170px;
            height:38px;
        .h-right
            display:flex;
            font-size:18px;
            // min-width:900px;
            line-height:80px;
            height:80px;
            align-items:center;
            justify-content:flex-end;
            .right-tab
                margin: 0 8px;
                padding:0 7px;
                cursor: pointer;
                color:#071336;
            a
                margin: 0 8px;
                color: rgba(7,19,54,0.6);
                font-size: 18px;
                padding: 0 7px;
                position: relative;
                &:after
                    content: '';
                    position: absolute;
                    left: 7px;
                    bottom: 0px;
                    width: 75%;
                    height: 4px;
                    transform: scaleX(0);
                    transform-origin: left center;
                    background: transparent;
                    transition: .3s;
                &:hover, &.active
                    color: #071336 !important;
                    font-weight:500 !important;
                    &:after
                      transform: scaleX(1);
                      background: #2751CB;
            .r-imgs
                display:flex;
                align-items:center;
                .r-img
                    width:20px;
                    height:20px;
                    margin-left:30px;
                    cursor: pointer;
            .r-title
                display:flex;
                align-items:center;
                position: relative;
                height:80px;
                line-height:80px;
                min-width:140px;
                .r-login
                    display:flex;
                    align-items:center;
                    cursor: pointer;
                  &:hover
                      .r-login
                          margin-left:0px;
                      .r-card
                          display: block;
                    .r-name
                        height:22px;
                        font-size:16px;
                        font-weight:500;
                        color:rgba(7,19,54,0.4);
                        line-height:22px;
                        margin-left:45px;
                    .r-name-list
                        display:flex;
                        flex-direction:column;
                        justify-content:center;
                        align-items:center;
                        margin-left:10px;
                        .r-name-img
                            width:48px;
                            height:48px;
                            border-radius:25px;
                        .r-name-icon
                            width: 0;
                            height: 0;
                            margin-top:5px;
                            border-width: 5px 5px 0;
                            border-style: solid;
                            border-color: #D5D5D5 transparent transparent;
                .r-card
                    display: none;
                    width: 174px;
                    background:rgba(255,255,255,1);
                    position: absolute;
                    top: 80px;
                    right: 0;
                    box-shadow:0px 2px 30px 0px rgba(0,0,0,0.17);
                    border-radius:10px;
                    div
                        text-align:center;
                        width:174px;
                        height:64px;
                        font-size:16px;
                        font-weight:400;
                        color:rgba(68,68,68,0.8);
                        line-height:64px;
                        cursor: pointer;
                .r-btn
                    margin-left:30px;
                    width:103px;
                    height:36px;
                    line-height:36px;
                    text-align:center;
                    background-color:#2751CB;
                    border-radius:26px;
                    font-size:16px;
                    font-weight:500;
                    color:#FFFFFF;
                    cursor: pointer;
@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0px, 0);
    transform: translate3d(0, 0px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue